// Shared API client for Finance Books frontend modules.
import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/fb`;

const ax = axios.create({ baseURL: API_BASE, withCredentials: true });

ax.interceptors.request.use((config) => {
  const t = localStorage.getItem('bsc_token');
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const fb = {
  get: (p, params) => ax.get(p, { params }).then((r) => r.data),
  post: (p, body) => ax.post(p, body).then((r) => r.data),
  put: (p, body) => ax.put(p, body).then((r) => r.data),
  del: (p) => ax.delete(p).then((r) => r.data),
};

export default fb;
